module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_750_Active@1x-c99cd021b75e6bba988df66930e97f7a.png";